import { OpcoUserStatus } from '../_OpcoUsersPage/ui/OpcoUserStatus/OpcoUserStatus';
import CheckedIcon from '@/images/CheckSmallIcon.svg?react';
import MinusIcon from '@/images/MinusSmallIcon.svg?react';
import { TableConfigItemsListType } from '@/components/Table/types/types';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';
import capitalize from 'lodash/capitalize';
import { SUBSCRIPTION_PLAN_TYPE } from '@/const/shared';
import { SubscriptionStatus } from '@/bundle/shared/components/SubscriptionStatus';
import { Box } from '@/components/Box/Box';
import { isPendingCancellationSubscriptionStatus } from '@/helpers/billingHelpers';
import { SubscriptionPendingCancellationDate } from '@/bundle/shared/components/SubscriptionPendingCancellationDateStatus';
import { OrganizationListItemType } from '@/api/v1/opco/organizations/getOrganizationsApi';

export const OPCO_ORGANIZATIONS_TABLE_CONFIG: TableConfigItemsListType<OrganizationListItemType> = [
  {
    key: 1,
    name: 'name,-date_created',
    header: 'NAME',
    width: '19%',
    hasSort: true,
    getValue({ name }) {
      return { value: name, title: name };
    },
  },
  {
    key: 2,
    name: 'date_created',
    header: 'CREATION DATE',
    width: '14%',
    hasSort: true,
    getValue({ date_created }) {
      return { value: formatDate(date_created) };
    },
  },
  {
    key: 3,
    name: 'status',
    header: 'STATUS',
    width: '14%',
    getValue({ status }) {
      return {
        value: <OpcoUserStatus status={status} />,
      };
    },
  },
  {
    key: 4,
    name: 'subscription_plan_type,-date_created',
    header: 'PLAN TYPE',
    width: '14%',
    hasSort: true,
    getValue({ subscription_plan_type }) {
      return { value: capitalize(subscription_plan_type) };
    },
  },
  {
    key: 5,
    name: 'billing_profile_object__subscription_object__status,-date_created',
    header: 'SUBSCRIPTION STATUS',
    width: '17%',
    hasSort: true,
    getValue({ subscription_plan_type, billing_profile }) {
      const isEnterprisePlan = subscription_plan_type === SUBSCRIPTION_PLAN_TYPE.ENTERPRISE;
      const subscription = billing_profile?.subscription;
      const subscriptionStatus = subscription?.status;

      if (isEnterprisePlan || !subscriptionStatus) return { value: <MinusIcon /> };

      const cancellationDate = subscription?.current_period_end;
      const isPendingCancellation = isPendingCancellationSubscriptionStatus(subscription);

      return {
        value: (
          <Box display='flex' rowGap='6px' columnGap='6px' flexWrap='wrap'>
            <SubscriptionStatus status={subscriptionStatus} />
            {isPendingCancellation && <SubscriptionPendingCancellationDate date={cancellationDate} />}
          </Box>
        ),
      };
    },
  },
  {
    key: 6,
    name: 'is_kyc_allowed,-date_created',
    header: 'ID',
    width: '8%',
    hasSort: true,
    getValue({ is_kyc_allowed }) {
      return { value: is_kyc_allowed ? <CheckedIcon /> : <MinusIcon /> };
    },
  },
  {
    key: 7,
    name: 'is_api_keys_allowed,-date_created',
    header: 'API',
    width: '8%',
    hasSort: true,
    getValue({ is_api_keys_allowed }) {
      return { value: is_api_keys_allowed ? <CheckedIcon /> : <MinusIcon /> };
    },
  },
];
